import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { Ge as d, hi as h, bo as b, M as r, fi as u } from "./abstract-base-8edf0a84-e11d45a3.js";
var p = {
    beaconTagName: "beacon-tab-panel"
  },
  v = d(_templateObject || (_templateObject = _taggedTemplateLiteral([":host(:not([active])){display:none}\n"])));
var f = Object.defineProperty,
  y = Object.getOwnPropertyDescriptor,
  i = function i(n, e, s, o) {
    for (var t = o > 1 ? void 0 : o ? y(e, s) : e, c = n.length - 1, l; c >= 0; c--) (l = n[c]) && (t = (o ? l(e, s, t) : l(t)) || t);
    return o && t && f(e, s, t), t;
  };
var a = /*#__PURE__*/function (_h) {
  _inherits(a, _h);
  function a() {
    var _this;
    _classCallCheck(this, a);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(a).apply(this, arguments)), _this.beaconTagName = p.beaconTagName, _this.active = !1, _this.ariaHidden = _this.active ? "false" : "true", _this.role = "tabpanel", _this.id = "tabpanel-0", _this.tabIndex = _this.active ? 0 : -1;
    return _this;
  }
  _createClass(a, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var e;
      (e = this.handleDefer()) == null || e.then(function () {
        _get(_getPrototypeOf(a.prototype), "connectedCallback", _this2).call(_this2);
      });
    }
    /**
     * updates the ID when the value is first initialized from the tabs component,
     * and sets the ariaHidden property and this.active property dependent on the this.active property
     * @param changedProperties an Inherited Map of properties that have changed since the last update.
     */
  }, {
    key: "willUpdate",
    value: function willUpdate(e) {
      e && e.has("active") && (this.ariaHidden = this.active ? "false" : "true", this.tabIndex = this.active ? 0 : -1);
    }
  }, {
    key: "render",
    value: function render() {
      return b(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<slot></slot>"])));
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(a), "styles", this), v];
    }
  }]);
  return a;
}(h(u));
a.tagName = p.beaconTagName;
i([r({
  reflect: !0
})], a.prototype, "value", 2);
i([r({
  type: Boolean,
  reflect: !0
})], a.prototype, "active", 2);
i([r({
  reflect: !0,
  attribute: "aria-hidden"
})], a.prototype, "ariaHidden", 2);
i([r({
  reflect: !0
})], a.prototype, "role", 2);
i([r({
  reflect: !0
})], a.prototype, "id", 2);
i([r({
  reflect: !0,
  attribute: "tabindex"
})], a.prototype, "tabIndex", 2);
export { a as BeaconTabPanel };